var map = {
	"./informatyka/config": "5759",
	"./informatyka/games/page001_game1/config": "0fd2",
	"./informatyka/games/page001_game2/config": "8c82",
	"./informatyka/games/page001_game3/config": "caa3",
	"./informatyka/games/page002_game0/config": "6108",
	"./informatyka/games/page002_game1/config": "31be",
	"./informatyka/games/page002_game2/config": "0968",
	"./informatyka/games/page002_game3/config": "ac33",
	"./informatyka/games/page002_game4/config": "5ad2",
	"./informatyka/games/page002_game5/config": "3e65",
	"./informatyka/games/page003_game1/config": "c54e",
	"./informatyka/games/page003_game2/config": "e05f",
	"./informatyka/games/page003_game4/config": "ad56",
	"./informatyka/games/page004_game4/config": "2cb3",
	"./informatyka/games/page005_game1/config": "3851",
	"./informatyka/games/page006_game1/config": "bbf9",
	"./informatyka/games/page006_game11/config": "d675",
	"./informatyka/games/page006_game2/config": "08bf",
	"./informatyka/games/page006_game3/config": "7e6f",
	"./informatyka/games/page007_game1/config": "9221",
	"./informatyka/games/page007_game2/config": "d982",
	"./informatyka/games/page007_game3/config": "d47f",
	"./informatyka/games/page007_game4/config": "b9d7",
	"./informatyka/games/page008_game1/config": "1b54",
	"./informatyka/games/page009_game1/config": "854f",
	"./informatyka/games/page009_game2/config": "72c9",
	"./informatyka/games/page009_game3/config": "54b5",
	"./informatyka/games/page010_game1/config": "97eb",
	"./informatyka/games/page010_game4/config": "2d3c",
	"./informatyka/games/page011_game3/config": "5fd2",
	"./informatyka/games/page011_game4/config": "33f5",
	"./informatyka/games/page011_game5/config": "d34b",
	"./informatyka/games/page012_game1/config": "355e",
	"./informatyka/games/page012_game4/config": "3ea1",
	"./informatyka/games/page013_game4/config": "ede1",
	"./informatyka/games/page013_game5/config": "26ae",
	"./informatyka/games/page014_game4/config": "64ee",
	"./informatyka/games/page016_game1/config": "3432",
	"./informatyka/games/page016_game10/config": "4183",
	"./informatyka/games/page016_game4/config": "a20c",
	"./informatyka/games/page016_game7/config": "700d",
	"./informatyka/games/page016_game8/config": "4826",
	"./informatyka/games/page016_game9/config": "4435",
	"./informatyka/games/page017_game1/config": "b48a",
	"./informatyka/games/page017_game10/config": "f858",
	"./informatyka/games/page017_game11/config": "8f31",
	"./informatyka/games/page017_game12/config": "66ce",
	"./informatyka/games/page017_game2/config": "71f4",
	"./informatyka/games/page018_game0/config": "d6f2",
	"./informatyka/games/page018_game1/config": "9a3f",
	"./informatyka/games/page019_game1/config": "c3ea",
	"./informatyka/games/page019_game10/config": "a1cf",
	"./informatyka/games/page019_game11/config": "2293",
	"./informatyka/games/page019_game3/config": "ac78",
	"./informatyka/games/page019_game4/config": "98ea",
	"./informatyka/games/page020_game1/config": "f577",
	"./informatyka/games/page020_game2/config": "5082",
	"./informatyka/games/page020_game3/config": "5c08",
	"./informatyka/games/page021_game1/config": "e41e",
	"./informatyka/games/page021_game10/config": "24dc",
	"./informatyka/games/page021_game11/config": "682c",
	"./informatyka/games/page021_game4/config": "747a",
	"./informatyka/games/page022_game3/config": "b55b",
	"./informatyka/games/page023_game1/config": "4452",
	"./informatyka/games/page024_game1/config": "7a15",
	"./informatyka/games/page024_game10/config": "2d6f",
	"./informatyka/games/page025_game1/config": "63fb",
	"./informatyka/games/page025_game10/config": "5a55",
	"./informatyka/games/page025_game2/config": "9a78",
	"./informatyka/games/page026_game1/config": "217c",
	"./informatyka/games/page026_game10/config": "7f66",
	"./informatyka/games/page026_game4/config": "3247",
	"./informatyka/games/page027_game1/config": "0304",
	"./informatyka/games/page027_game8/config": "d8d0",
	"./informatyka/games/page027_game9/config": "0f83",
	"./informatyka/games/page029_game10/config": "7542",
	"./informatyka/games/page029_game11/config": "67bf",
	"./informatyka/games/page030_game10/config": "1962",
	"./informatyka/games/page031_game10/config": "9b0a",
	"./informatyka/games/page031_game11/config": "a466",
	"./informatyka/games/page034_game10/config": "4d70",
	"./informatyka/games/page035_game10/config": "ab01",
	"./informatyka/games/page035_game11/config": "a309",
	"./informatyka/games/page035_game12/config": "188f",
	"./informatyka/games/page037_game10/config": "9543",
	"./informatyka/games/page037_game11/config": "fd0a",
	"./informatyka/games/page037_game12/config": "f7bb",
	"./informatyka/games/page039_game10/config": "7e22",
	"./informatyka/games/page039_game11/config": "bbcf",
	"./informatyka/games/page040_game10/config": "0388",
	"./informatyka/games/page042_game10/config": "9cc0",
	"./informatyka/games/page043_game10/config": "7629",
	"./informatyka/games/page045_game10/config": "ebe3",
	"./informatyka/games/page045_game11/config": "c42e",
	"./informatyka/games/page050_game10/config": "1466",
	"./informatyka/games/page051_game10/config": "e51e",
	"./informatyka/games/page051_game11/config": "9026",
	"./informatyka/games/page051_game12/config": "68d2",
	"./informatyka/games/page997_game1/config": "225b",
	"./informatyka/games/page997_game2/config": "87f4",
	"./informatyka/scratchPad/page001_game0/config": "e248",
	"./informatyka/scratchPad/page001_game1/config": "d406",
	"./informatyka/scratchPad/page002_game0/config": "042d",
	"./informatyka/scratchPad/page002_game1/config": "3ce6",
	"./informatyka/scratchPad/page002_game2/config": "875e",
	"./informatyka/scratchPad/page003_game0/config": "07ab",
	"./informatyka/scratchPad/page003_game1/config": "da6b",
	"./informatyka/scratchPad/page003_game2/config": "1f50",
	"./informatyka/scratchPad/page006_game0/config": "f5b2",
	"./informatyka/scratchPad/page007_game0/config": "6c67",
	"./informatyka/scratchPad/page007_game1/config": "dcb2",
	"./informatyka/scratchPad/page008_game0/config": "fc18",
	"./informatyka/scratchPad/page008_game1/config": "1773",
	"./informatyka/scratchPad/page009_game0/config": "e0d2",
	"./informatyka/scratchPad/page009_game1/config": "c308"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cf6f";